import { render } from "./DeleteCustomFieldsModal.vue?vue&type=template&id=19e7020e"
import script from "./DeleteCustomFieldsModal.vue?vue&type=script&lang=js"
export * from "./DeleteCustomFieldsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__